'use client';
import { ReactNode } from 'react';

import { AuthProvider } from 'react-oidc-context';

const oidcConfig = {
  authority: `${process.env.NEXT_PUBLIC_SSO_AUTHORITY_URL}`,
  client_id: 'TourismB2CSPA',
  redirect_uri: `${process.env.NEXT_PUBLIC_HOST}/sso-callback`,
  response_type: 'code',
  scope: 'openid profile offline_access',
  automaticSilentRenew: false,
  post_logout_redirect_uri: `${process.env.NEXT_PUBLIC_HOST}/sso-callback`,
};

const OIDCProvider = ({ children }: { children: ReactNode }) => {
  return <AuthProvider {...oidcConfig}>{children} </AuthProvider>;
};

export default OIDCProvider;
